// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.conversation-detail {
    padding: 20px;
    max-width: 1200px;
    margin: 0 auto;
}

.conversation-detail .loading,
.conversation-detail .error-container {
    text-align: center;
    padding: 40px;
}

.conversation-detail .error {
    color: #F44336;
    font-size: 1.1rem;
    margin-bottom: 20px;
}

/* Header */
.detail-header {
    display: flex;
    align-items: center;
    gap: 20px;
    margin-bottom: 24px;
    flex-wrap: wrap;
}

.detail-header h1 {
    margin: 0;
    font-size: 1.8rem;
    color: #333;
    flex: 1 1;
}

.btn-back {
    background: #f5f5f5;
    border: 1px solid #ddd;
    padding: 10px 16px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 0.95rem;
    transition: all 0.2s;
    color: #333;
}

.btn-back:hover {
    background: #e8e8e8;
    border-color: #ccc;
}

/* Live Chat Button */
.btn-live-chat {
    background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
    color: white;
    padding: 10px 20px;
    border-radius: 8px;
    text-decoration: none;
    font-weight: 600;
    font-size: 0.95rem;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    transition: all 0.2s;
    box-shadow: 0 2px 8px rgba(37, 211, 102, 0.3);
}

.btn-live-chat:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(37, 211, 102, 0.4);
}

.btn-live-chat:active {
    transform: translateY(0);
}

/* Info Card */
.info-card {
    margin-bottom: 24px;
}

.info-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 16px;
}

.info-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.info-item.full-width {
    grid-column: 1 / -1;
}

.info-label {
    font-size: 0.85rem;
    color: #666;
    font-weight: 500;
}

.info-value {
    font-size: 1.1rem;
    color: #333;
    font-weight: 600;
}

.platform-badge {
    display: inline-block;
    padding: 4px 12px;
    border-radius: 16px;
    font-size: 0.9rem;
    font-weight: 500;
    color: white;
    width: fit-content;
}

.platform-badge.whatsapp {
    background: #25D366;
}

.platform-badge.instagram {
    background: linear-gradient(45deg, #405DE6, #C13584, #F77737);
}

.platform-badge.instagram_dm {
    background: linear-gradient(135deg, #833AB4, #C13584, #E1306C);
}

.platform-badge.facebook {
    background: #1877F2;
}

.platform-badge.facebook_message {
    background: #0084FF;
}

.platform-badge.tiktok {
    background: #000;
}

.sentiment-badge {
    display: inline-block;
    padding: 4px 12px;
    border-radius: 16px;
    font-size: 0.9rem;
    font-weight: 500;
    color: white;
    width: fit-content;
    text-transform: capitalize;
}

.escalated-alert {
    background: #FFF3E0;
    color: #E65100;
    padding: 12px 16px;
    border-radius: 8px;
    font-weight: 600;
    display: inline-block;
}

/* Messages Card */
.messages-card {
    margin-bottom: 24px;
}

.messages-card h2 {
    margin: 0 0 20px 0;
    font-size: 1.3rem;
    color: #333;
    border-bottom: 2px solid #eee;
    padding-bottom: 12px;
}

/* Messages Timeline */
.messages-timeline {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.message-item {
    display: flex;
    gap: 12px;
    position: relative;
}

.message-item.inbound {
    flex-direction: row;
}

.message-item.outbound {
    flex-direction: row-reverse;
}

.message-timeline-dot {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #f5f5f5;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
    flex-shrink: 0;
    border: 2px solid #e0e0e0;
}

.message-item.inbound .message-timeline-dot {
    background: #E3F2FD;
    border-color: #90CAF9;
}

.message-item.outbound .message-timeline-dot {
    background: #E8F5E9;
    border-color: #A5D6A7;
}

.message-content-box {
    flex: 1 1;
    max-width: 70%;
    background: #f9f9f9;
    border-radius: 12px;
    padding: 12px 16px;
    border: 1px solid #eee;
}

.message-item.inbound .message-content-box {
    background: #E3F2FD;
    border-color: #BBDEFB;
}

.message-item.outbound .message-content-box {
    background: #E8F5E9;
    border-color: #C8E6C9;
    margin-left: auto;
}

.message-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
    margin-bottom: 8px;
}

.message-sender {
    font-weight: 600;
    font-size: 0.9rem;
    color: #333;
}

.message-timestamp {
    font-size: 0.8rem;
    color: #888;
}

.sentiment-mini {
    font-size: 0.75rem;
    padding: 2px 8px;
    border-radius: 10px;
    color: white;
    font-weight: 500;
}

.message-text-content {
    font-size: 1rem;
    line-height: 1.5;
    color: #333;
    word-wrap: break-word;
}

.message-response-time {
    margin-top: 8px;
    font-size: 0.8rem;
    color: #666;
}

.no-messages {
    text-align: center;
    padding: 40px;
    color: #888;
    font-style: italic;
}

/* Card styling */
.conversation-detail .card {
    background: white;
    border-radius: 12px;
    padding: 24px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

/* Responsive */
@media (max-width: 768px) {
    .conversation-detail {
        padding: 12px;
    }

    .detail-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
    }

    .detail-header h1 {
        font-size: 1.4rem;
    }

    .info-grid {
        grid-template-columns: 1fr 1fr;
    }

    .message-content-box {
        max-width: 85%;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/ConversationDetail.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iBAAiB;IACjB,cAAc;AAClB;;AAEA;;IAEI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA,WAAW;AACX;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,WAAW;IACX,SAAO;AACX;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,qBAAqB;AACrB;IACI,6DAA6D;IAC7D,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,oBAAoB;IACpB,6CAA6C;AACjD;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,cAAc;AACd;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,8DAA8D;AAClE;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA,kBAAkB;AAClB;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,6BAA6B;IAC7B,oBAAoB;AACxB;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,SAAO;IACP,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,kBAAkB;AACtB;;AAEA,iBAAiB;AACjB;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,yCAAyC;AAC7C;;AAEA,eAAe;AACf;IACI;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,cAAc;IAClB;AACJ","sourcesContent":[".conversation-detail {\n    padding: 20px;\n    max-width: 1200px;\n    margin: 0 auto;\n}\n\n.conversation-detail .loading,\n.conversation-detail .error-container {\n    text-align: center;\n    padding: 40px;\n}\n\n.conversation-detail .error {\n    color: #F44336;\n    font-size: 1.1rem;\n    margin-bottom: 20px;\n}\n\n/* Header */\n.detail-header {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    margin-bottom: 24px;\n    flex-wrap: wrap;\n}\n\n.detail-header h1 {\n    margin: 0;\n    font-size: 1.8rem;\n    color: #333;\n    flex: 1;\n}\n\n.btn-back {\n    background: #f5f5f5;\n    border: 1px solid #ddd;\n    padding: 10px 16px;\n    border-radius: 8px;\n    cursor: pointer;\n    font-size: 0.95rem;\n    transition: all 0.2s;\n    color: #333;\n}\n\n.btn-back:hover {\n    background: #e8e8e8;\n    border-color: #ccc;\n}\n\n/* Live Chat Button */\n.btn-live-chat {\n    background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);\n    color: white;\n    padding: 10px 20px;\n    border-radius: 8px;\n    text-decoration: none;\n    font-weight: 600;\n    font-size: 0.95rem;\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    transition: all 0.2s;\n    box-shadow: 0 2px 8px rgba(37, 211, 102, 0.3);\n}\n\n.btn-live-chat:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(37, 211, 102, 0.4);\n}\n\n.btn-live-chat:active {\n    transform: translateY(0);\n}\n\n/* Info Card */\n.info-card {\n    margin-bottom: 24px;\n}\n\n.info-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 16px;\n}\n\n.info-item {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.info-item.full-width {\n    grid-column: 1 / -1;\n}\n\n.info-label {\n    font-size: 0.85rem;\n    color: #666;\n    font-weight: 500;\n}\n\n.info-value {\n    font-size: 1.1rem;\n    color: #333;\n    font-weight: 600;\n}\n\n.platform-badge {\n    display: inline-block;\n    padding: 4px 12px;\n    border-radius: 16px;\n    font-size: 0.9rem;\n    font-weight: 500;\n    color: white;\n    width: fit-content;\n}\n\n.platform-badge.whatsapp {\n    background: #25D366;\n}\n\n.platform-badge.instagram {\n    background: linear-gradient(45deg, #405DE6, #C13584, #F77737);\n}\n\n.platform-badge.instagram_dm {\n    background: linear-gradient(135deg, #833AB4, #C13584, #E1306C);\n}\n\n.platform-badge.facebook {\n    background: #1877F2;\n}\n\n.platform-badge.facebook_message {\n    background: #0084FF;\n}\n\n.platform-badge.tiktok {\n    background: #000;\n}\n\n.sentiment-badge {\n    display: inline-block;\n    padding: 4px 12px;\n    border-radius: 16px;\n    font-size: 0.9rem;\n    font-weight: 500;\n    color: white;\n    width: fit-content;\n    text-transform: capitalize;\n}\n\n.escalated-alert {\n    background: #FFF3E0;\n    color: #E65100;\n    padding: 12px 16px;\n    border-radius: 8px;\n    font-weight: 600;\n    display: inline-block;\n}\n\n/* Messages Card */\n.messages-card {\n    margin-bottom: 24px;\n}\n\n.messages-card h2 {\n    margin: 0 0 20px 0;\n    font-size: 1.3rem;\n    color: #333;\n    border-bottom: 2px solid #eee;\n    padding-bottom: 12px;\n}\n\n/* Messages Timeline */\n.messages-timeline {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.message-item {\n    display: flex;\n    gap: 12px;\n    position: relative;\n}\n\n.message-item.inbound {\n    flex-direction: row;\n}\n\n.message-item.outbound {\n    flex-direction: row-reverse;\n}\n\n.message-timeline-dot {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    background: #f5f5f5;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 1.2rem;\n    flex-shrink: 0;\n    border: 2px solid #e0e0e0;\n}\n\n.message-item.inbound .message-timeline-dot {\n    background: #E3F2FD;\n    border-color: #90CAF9;\n}\n\n.message-item.outbound .message-timeline-dot {\n    background: #E8F5E9;\n    border-color: #A5D6A7;\n}\n\n.message-content-box {\n    flex: 1;\n    max-width: 70%;\n    background: #f9f9f9;\n    border-radius: 12px;\n    padding: 12px 16px;\n    border: 1px solid #eee;\n}\n\n.message-item.inbound .message-content-box {\n    background: #E3F2FD;\n    border-color: #BBDEFB;\n}\n\n.message-item.outbound .message-content-box {\n    background: #E8F5E9;\n    border-color: #C8E6C9;\n    margin-left: auto;\n}\n\n.message-meta {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    align-items: center;\n    margin-bottom: 8px;\n}\n\n.message-sender {\n    font-weight: 600;\n    font-size: 0.9rem;\n    color: #333;\n}\n\n.message-timestamp {\n    font-size: 0.8rem;\n    color: #888;\n}\n\n.sentiment-mini {\n    font-size: 0.75rem;\n    padding: 2px 8px;\n    border-radius: 10px;\n    color: white;\n    font-weight: 500;\n}\n\n.message-text-content {\n    font-size: 1rem;\n    line-height: 1.5;\n    color: #333;\n    word-wrap: break-word;\n}\n\n.message-response-time {\n    margin-top: 8px;\n    font-size: 0.8rem;\n    color: #666;\n}\n\n.no-messages {\n    text-align: center;\n    padding: 40px;\n    color: #888;\n    font-style: italic;\n}\n\n/* Card styling */\n.conversation-detail .card {\n    background: white;\n    border-radius: 12px;\n    padding: 24px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n    .conversation-detail {\n        padding: 12px;\n    }\n\n    .detail-header {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 12px;\n    }\n\n    .detail-header h1 {\n        font-size: 1.4rem;\n    }\n\n    .info-grid {\n        grid-template-columns: 1fr 1fr;\n    }\n\n    .message-content-box {\n        max-width: 85%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
